import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Container,
  GridContainer,
  InputFieldsWrapper,
} from "styles/pages/manage-account";
import { Table } from "reactstrap";
import AlertModal from "components/AlertModal";
import Select from "components/FormElements/Select";
import states from "states-us";
import DownloadIcon from "assets/svg/DownloadIcon";
import GetCetModal from "components/GetCetModal";
import { certificateListDetails } from "redux/actions/manageAccount";
import { useText } from "locales/useGetText";
import { getCanadaStates, getLoggedInUserCountry } from "helpers";
import { downloadFile } from "helpers/downloadFile";

function TaxExemption(pageProps) {
  const [accordionOpen, setAccordionOpen] = useState(false);
  const locale = useText("textEmp");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedInUserInfo = JSON.parse(localStorage.getItem("loggedInUserData"));
  const token = loggedInUserInfo?.token;
  const userCountry = (loggedInUserInfo?.country || getLoggedInUserCountry() || "USA").toUpperCase();
  const countryCode = userCountry;

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  let title = "";

  const [genCetModal, setGenCetModal] = useState(false);
  const genCetToggleModal = () => setGenCetModal(!genCetModal);

  const [genCetListResponse, setGenCetListResponse] = useState(undefined);
  const territoryStates = states.filter((x) => x.contiguous);
  const getStateFullName = (state) => {
    if (!state) return "";
    const normalizedState = `${state}`.trim();
    if (userCountry === "CANADA") {
      return getCanadaStates.find((item) => item.isoCode === normalizedState.toUpperCase())?.name
        || getCanadaStates.find((item) => item.name.toLowerCase() === normalizedState.toLowerCase())?.name
        || normalizedState;
    }
    return territoryStates.find((item) => item.abbreviation === normalizedState.toUpperCase())?.name
      || territoryStates.find((item) => item.name.toLowerCase() === normalizedState.toLowerCase())?.name
      || normalizedState;
  };
  const [stateVal, setStateVal] = useState(
    getStateFullName(pageProps?.pageData?.locationAddress?.stateFullName || pageProps?.pageData?.locationAddress?.state)
  );

  useEffect(() => {
    setStateVal(
      getStateFullName(pageProps?.pageData?.locationAddress?.stateFullName || pageProps?.pageData?.locationAddress?.state)
    );
  }, [countryCode, pageProps?.pageData?.locationAddress?.state, pageProps?.pageData?.locationAddress?.stateFullName]);

  const getCertTableDataAPI = async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/sign-in");
      toggleModal();
    } else {
      let response = await dispatch(
        certificateListDetails(token, pageProps.pageData.id)
      );
      if (response?.value) {
        setGenCetListResponse(response?.value);
      }
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      getCertTableDataAPI();
    }
  }, []);

  let stateArr = [];
  if (userCountry === "CANADA") {
    stateArr = getCanadaStates.map((item) => ({
      value: item.name,
      label: `${item.isoCode}-${item.name}`,
      isoCode: item.isoCode,
    }));
  } else {
    for (let i = 0; i < territoryStates.length; i++) {
      if (territoryStates[i].name !== "District Of Columbia") {
        stateArr.push({
          value: territoryStates[i].name,
          label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
          isoCode: territoryStates[i].abbreviation,
        });
      }
    }
  }

  // const downloadDocuments = async (genCetId) => {
  //   if (token === null) {
  //     setModalContent("Please Sign In again.");
  //     setModalLink("/sign-in");
  //     toggleModal();
  //   } else {
  //     const fileUrl =
  //       process.env.REACT_APP_API_URL +
  //       "/tax/download_certificate?id=" +
  //       pageProps.pageData.id +
  //       "&c_id=" +
  //       genCetId;
  //     window.open(fileUrl);
  //   }
  // };

  const downloadDocuments = async (genCetId) => {
    const fileUrl = process.env.REACT_APP_API_URL + "/tax/download_certificate?id=" + pageProps.pageData.id + "&c_id=" + genCetId;
    dispatch(downloadFile('tax-exemption-certificate.pdf', fileUrl, token));
  };

  return (
    <>
      <Container>
        <GridContainer>
          <h6 style={{ "padding-bottom": "0" }} onClick={() => { }}>
            {locale('taxExemptionTitle')} - <span>{userCountry === 'CANADA' ? locale('taxExemptionSubtitleCanada') : locale('taxExemptionSubtitle')}</span>
          </h6>
          <InputFieldsWrapper>
            <p
              style={{
                color: "#000000",
                marginTop: "15px",
                "font-size": "15px",
              }}
            >
              {locale('manageTaxExemption')}
            </p>

            <div style={{ display: "flex", marginBottom: "20px" }}>
              <div style={{ width: "300px" }}>
                <Select
                  name="stateTaxExemption"
                  data={stateArr}
                  searchable={true}
                  onChangeHandler={(value) => {
                    setStateVal(value);
                  }}
                />
              </div>
              <button
                style={{ height: "38px", marginLeft: "10px" }}
                className="green-button"
                onClick={(e) => {
                  if (stateVal) {
                    genCetToggleModal();
                  } else {
                    setModalContent(locale('selectStateFirst'));
                    setModalLink("");
                    toggleModal();
                  }
                }}
              >
                {locale('exemptionForm')}
              </button>
            </div>
            <div>
              <Table responsive>
                <thead>
                  <tr>
                    <th>{userCountry === 'CANADA' ? locale('province') : locale('state')}</th>
                    <th>{locale('signedDate')}</th>
                    <th>{locale('expirationDate')}</th>
                    <th>{locale('status')}</th>
                    <th className="text-center" style={{ width: "137px" }}>
                      {locale('document')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {genCetListResponse ? (
                    genCetListResponse.map((data, index) => {
                      return (
                        <tr>
                          <th>{data.exposureZone.name}</th>
                          <th>{data.signedDate}</th>
                          <th>{data.expirationDate}</th>
                          <th>{data.status}</th>
                          <th className="text-center">
                            <button
                              className="download-btn"
                              onClick={() => {
                                downloadDocuments(data.id);
                              }}
                            >
                              <DownloadIcon />
                            </button>
                          </th>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th className="text-center"></th>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </InputFieldsWrapper>

        </GridContainer>

        {genCetModal && (
          <GetCetModal
            isOpen={genCetModal}
            toggle={genCetToggleModal}
            title={""}
            id={pageProps.pageData.id}
            selectedState={stateVal}
            onClickHander={(val) => {
              genCetToggleModal();
            }}
            callBack={() => {
              getCertTableDataAPI();
              genCetToggleModal();
            }}
            getCetType="PTMS"
            content={""}
            link={""}
          />
        )}

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={title}
          content={modalContent}
          // alertType={alertTypeState}
          link={modalLink}
          callBackAlert={(val) => {
            toggleModal();
          }}
        />
      </Container>
    </>
  );
}

export default TaxExemption;
